import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import type { BillingFormValues } from '@/entities/billing';
import type { Plan } from '@/shared/api/types';

interface OnboardingState {
  selectedPlan: Plan | null;
  // Values of the billing form
  presetBillingAddress: BillingFormValues | null;
}

const INITIAL_STATE: OnboardingState = {
  selectedPlan: null,
  presetBillingAddress: null,
};

const onboardingSlice = createSlice({
  name: 'onBoarding',
  initialState: INITIAL_STATE,
  reducers: {
    setSelectedPlan: (state, action: PayloadAction<Plan | null>) => {
      state.selectedPlan = action.payload;
    },

    saveBillingAddress: (
      state,
      action: PayloadAction<BillingFormValues | null>,
    ) => {
      state.presetBillingAddress = action.payload;
    },

    logout: () => INITIAL_STATE,
  },
});

export const { setSelectedPlan, saveBillingAddress } = onboardingSlice.actions;

export const reducer = onboardingSlice.reducer;
